"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.json.stringify.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _Title = _interopRequireDefault(require("./components/Title"));

var _CoinInfo = _interopRequireDefault(require("./components/recharge_withdrawal/CoinInfo"));

var _History = _interopRequireDefault(require("./components/recharge_withdrawal/History"));

var _WithdrawalAddress = _interopRequireDefault(require("./components/withdrawal/WithdrawalAddress"));

var _WithdrawalExplain = _interopRequireDefault(require("./components/withdrawal/WithdrawalExplain"));

var _ChargeExplain = _interopRequireDefault(require("./components/recharge/ChargeExplain"));

var _ChargeFragment = _interopRequireDefault(require("./components/recharge/ChargeFragment"));

var _message = require("@/components/dialog/message.js");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _index = require("@/model/assets/index");

var _getAssetsCoin = require("./common/getAssetsCoin");

var _momentTimezone = require("moment-timezone");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import WithdrawFaq from "./components/withdrawal/withdrawFaq";
// import ChargeMaintainFragment from "./components/recharge/ChargeMaintainFragment";
// 充币页面
var _default = {
  mixins: [_commonMixin.default],
  data: function data() {
    return {
      isPageLoading: true,
      //页面加载loading
      safetyVerification: false,
      activeName: "1",
      data: {},
      // 单项资产数据
      coinName: "",
      exchangeList: [],
      // 充提币记录
      assetsList: {},
      // 资产列表
      isRecharge: true,
      // 是否是提币
      exchangeLimit: {},
      // 提币限额
      accountInfo: {},
      withdrawTip: "",
      multi_chain_status: 1,
      historyLoading: true,
      chainMap: {},
      is_trade: true,
      operationList: [{
        value: 1,
        label: "充值"
      }, {
        value: 2,
        label: "提现"
      } // { value: 3, label: "交易" },
      ],
      currActicve: 1,
      pageInfo: {
        pageCount: 0,
        pageTotal: 0,
        pageSize: 10,
        pageCurrent: 1
      },
      pageNum: 1
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var currentCoin, routeName, coin_name, key;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // let currentCoin = JSON.parse(sessionStorage.getItem("currentCoin"));
              currentCoin = JSON.parse(localStorage.getItem("currentCoin"));
              _this.is_trade = currentCoin.is_trade; // this.initOperition();

              routeName = _this.$route.name;
              coin_name = _this.$route.params.coin;

              if (coin_name) {
                _this.coinName = coin_name;
              }

              _this.isRecharge = routeName === "recharge";
              _this.currActicve = _this.isRecharge ? "1" : "2";
              _context.next = 9;
              return (0, _getAssetsCoin.getCoinInfo)();

            case 9:
              _this.coinData = _context.sent;

              _this.initialData();

              _this.data = (0, _getAssetsCoin.getCurrentCoin)();

              for (key in _this.coinData) {
                if (_this.coinData[key].item_name == _this.$route.params.coin) {
                  _this.data = _this.coinData[key];
                }
              }

              if (_this.isRecharge && !_this.data.itemDetail.in_status) {
                (0, _message.showMessage)({
                  message: _this.translateTitle("\u5F53\u524D\u5E01\u79CD\u6682\u4E0D\u652F\u6301\u5145\u5E01"),
                  type: "warning",
                  duration: 1200
                });

                _this.$router.push(_this.routeSplicing(_this.language, "ucenter/assets"));
              }

              if (!_this.isRecharge && !_this.data.itemDetail.out_status) {
                (0, _message.showMessage)({
                  message: _this.translateTitle("\u5F53\u524D\u5E01\u79CD\u6682\u4E0D\u652F\u6301\u63D0\u5E01"),
                  type: "warning",
                  duration: 1200
                });

                _this.$router.push(_this.routeSplicing(_this.language, "ucenter/assets"));
              }

              _context.next = 17;
              return (0, _getAssetsCoin.getAssetsData)();

            case 17:
              _this.assetsList = _context.sent;
              _context.next = 20;
              return _this.getExchangeList(_this.data.item_id);

            case 20:
              _context.next = 22;
              return _this.getUserExchangeLimit(_this.data.item_id);

            case 22:
              _this.isPageLoading = false;

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language"
  })),
  methods: {
    routeSplicing: _routeSplicing.default,
    handleClick: function handleClick() {},
    // initOperition() {
    //   this.operationList = [];
    //   if (!this.is_trade) {
    //     this.operationList = [
    //       { value: 1, label: "充值" },
    //       { value: 2, label: "提现" },
    //     ];
    //   } else {
    //     this.operationList = [
    //       { value: 1, label: "充值" },
    //       { value: 2, label: "提现" },
    //       { value: 3, label: "交易" },
    //     ];
    //   }
    // },
    onChangeTab: function onChangeTab(item) {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var active, userInfo, tempUrl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                active = item.value;

                if (active == 1) {
                  _this2.currActicve = item.value;
                  _this2.isRecharge = true;

                  _this2.getExchangeList(_this2.data.item_id);

                  _this2.$router.push({
                    path: _this2.routeSplicing(_this2.language, "ucenter/assets/recharge/" + _this2.coinName.toLowerCase())
                  });
                } else if (active == 2) {
                  userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

                  if (userInfo.authInfo.is_bind_security == 1 && userInfo.authInfo.open_google == 0) {
                    _this2.safetyVerification = true;
                  } else {
                    _this2.currActicve = item.value;
                    _this2.isRecharge = false;

                    _this2.getExchangeList(_this2.data.item_id);

                    _this2.$router.push({
                      path: _this2.routeSplicing(_this2.language, "ucenter/assets/withdrawal/" + _this2.coinName.toLowerCase())
                    });
                  }
                } else {
                  tempUrl = _this2.routeSplicing(_this2.language, "exchange/".concat(_this2.coinName.toLowerCase(), "_", "usdt")); //  location.href(tempUrl)

                  window.open(tempUrl);
                }

                _context2.next = 4;
                return (0, _getAssetsCoin.getAssetsData)();

              case 4:
                _this2.assetsList = _context2.sent;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onConfirmV2: function onConfirmV2() {
      this.$router.push(this.routeSplicing(this.language, "ucenter/safe-setting"));
    },
    getChainData: function getChainData(val) {
      this.chainMap = val;
    },
    // 获取 24h 内的提币限制
    getUserExchangeLimit: function getUserExchangeLimit(item_id) {
      var _this3 = this;

      var params = {
        item_id: item_id
      };
      (0, _index.getUserExchangeLimit)(params).then(function (_ref) {
        var status = _ref.status,
            data = _ref.data,
            msg = _ref.msg;

        if (status === 200) {
          _this3.exchangeLimit = data;
        } else {
          (0, _message.showMessage)({
            message: msg ? msg : status
          });
        }
      });
    },
    //前往充，提币页面
    goFinance: function goFinance() {
      /* 充币记录 */
      this.$router.push({
        path: "/ucenter/financeManager",
        query: {
          indexItem: this.isRecharge ? 1 : 2,
          coinId: this.data.item_id
        }
      });
    },
    // 提币成功
    withdrawSuccess: function withdrawSuccess(list) {
      this.assetsList = list;
      this.getExchangeList(this.data.item_id);
      this.getUserExchangeLimit(this.data.item_id);
    },
    // 初始化数据
    initialData: function initialData() {
      this.bindMobileModel = {};
      this.bindEmailModel = {
        email: ""
      };
      this.bindGoogleModel = {};
    },
    // 获取页面新数据
    getNewData: function getNewData(data) {
      this.exchangeLimit = {};

      if (!this.isRecharge) {
        this.$refs.withDrawalAddress.$refs.changePwdForm.resetFields();
      }

      this.data = data;
      this.multi_chain_status = data.itemDetail.multi_chain_status;
      this.getExchangeList(data.item_id);
      this.getUserExchangeLimit(this.data.item_id);
    },
    //页数变更
    onPageChange: function onPageChange(val) {
      this.pageNum = val;
      this.getExchangeList(this.data.item_id);
    },
    // 获取 充值/提币 记录
    getExchangeList: function getExchangeList(item_id) {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var type;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = _this4.isRecharge ? 1 : 2;
                _this4.historyLoading = true;

                if (!(type == 1)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 5;
                return (0, _index.getINCoinExchangeListV2)({
                  item_id: item_id,
                  type: type,
                  // page_size: 8,
                  // page: 1,
                  page: !isNaN(_this4.pageNum) ? _this4.pageNum : 1,
                  page_size: _this4.pageInfo.pageSize ? _this4.pageInfo.pageSize : 10
                }).then(function (_ref2) {
                  var status = _ref2.status,
                      data = _ref2.data,
                      msg = _ref2.msg;

                  if (status === 200) {
                    _this4.exchangeList = data.list;
                    _this4.pageInfo = JSON.parse(JSON.stringify(data.pageInfo));
                  } else {
                    (0, _message.showMessage)({
                      message: msg ? msg : status
                    });
                  }
                });

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.next = 9;
                return (0, _index.getExchangeListV2)({
                  item_id: item_id,
                  type: type,
                  // page_size: 8,
                  // page: 1,
                  page: !isNaN(_this4.pageNum) ? _this4.pageNum : 1,
                  page_size: _this4.pageInfo.pageSize ? _this4.pageInfo.pageSize : 10
                }).then(function (_ref3) {
                  var status = _ref3.status,
                      data = _ref3.data,
                      msg = _ref3.msg;

                  if (status === 200) {
                    _this4.exchangeList = data.list;
                    _this4.pageInfo = JSON.parse(JSON.stringify(data.pageInfo));
                  } else {
                    (0, _message.showMessage)({
                      message: msg ? msg : status
                    });
                  }
                });

              case 9:
                _this4.historyLoading = false;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  components: {
    TopTitle: _Title.default,
    CoinInfo: _CoinInfo.default,
    ChargeExplain: _ChargeExplain.default,
    History: _History.default,
    WithdrawalAddress: _WithdrawalAddress.default,
    WithdrawalExplain: _WithdrawalExplain.default,
    ChargeFragment: _ChargeFragment.default // WithdrawFaq,
    // ChargeMaintainFragment

  }
};
exports.default = _default;